import {
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Typography
} from "@mui/material";
import { styled } from "@mui/system";
import { useEffect } from "react";
import { NumericFormat } from "react-number-format";

const StyledTextField = styled(TextField)({
  minWidth: "80px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#E9EAEC",
    borderRadius: "10px"
  },
  "& .MuiInputBase-root.Mui-disabled": {
    backgroundColor: "rgb(255, 255, 255)",
    borderColor: "rgb(179, 179, 179)",
    outline: "none",
    "& fieldset": {
      borderColor: "rgb(179, 179, 179)",
      borderWidth: "0.5px"
    }
  }
});

export const Section7 = ({
  formState,
  handleChange,
  handleSectionComplete,
  reportId,
  isEditingEnabled
}) => {
  useEffect(() => {
    const categories = [
      "evangelism",
      "choir",
      "key_teachers",
      "small_group_leaders",
      "shepherding",
      "sunday_school_teachers",
      "married_couples",
      "unmarried_youth",
      "youth",
      "sisters",
      "general_servants",
      "growing_youth",
      "former_leaders",
      "department_leaders",
      "new_leaders",
      "peace_building",
      "dual_ministry"
    ];
    // Calculate all totals in one go to batch the updates
    const updates = categories.reduce((acc, category) => {
      const male = Number(formState.training[category].male) || 0;
      const female = Number(formState.training[category].female) || 0;
      const total = male + female;
      if (total !== formState.training[category].total) {
        acc[category] = {
          ...formState.training[category],
          total
        };
      }
      return acc;
    }, {});
    // Only update if there are changes
    if (Object.keys(updates).length > 0) {
      handleChange("training", "all", {
        ...updates
      });
    }
  }, [
    formState.training.evangelism.male,
    formState.training.evangelism.female,
    formState.training.choir.male,
    formState.training.choir.female,
    formState.training.key_teachers.male,
    formState.training.key_teachers.female,
    formState.training.small_group_leaders.male,
    formState.training.small_group_leaders.female,
    formState.training.shepherding.male,
    formState.training.shepherding.female,
    formState.training.sunday_school_teachers.male,
    formState.training.sunday_school_teachers.female,
    formState.training.married_couples.male,
    formState.training.married_couples.female,
    formState.training.unmarried_youth.male,
    formState.training.unmarried_youth.female,
    formState.training.youth.male,
    formState.training.youth.female,
    formState.training.sisters.male,
    formState.training.sisters.female,
    formState.training.general_servants.male,
    formState.training.general_servants.female,
    formState.training.growing_youth.male,
    formState.training.growing_youth.female,
    formState.training.former_leaders.male,
    formState.training.former_leaders.female,
    formState.training.department_leaders.male,
    formState.training.department_leaders.female,
    formState.training.new_leaders.male,
    formState.training.new_leaders.female,
    formState.training.peace_building.male,
    formState.training.peace_building.female,
    formState.training.dual_ministry.male,
    formState.training.dual_ministry.female
  ]);

  return (
    <Stack spacing={2}>
      <TableContainer sx={{ overflowX: "auto" }}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell></TableCell>
              <TableCell align="center">ወንድ</TableCell>
              <TableCell align="center">ሴት</TableCell>
              <TableCell align="center">ድምር</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ከወንጌል ስርጭት አኳያ የሰለጠኑ ሰዎች ብዛት</TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.evangelism.male}
                  onValueChange={values => {
                    handleChange("training", "evangelism", {
                      ...formState.training.evangelism,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.evangelism.female}
                  onValueChange={values => {
                    handleChange("training", "evangelism", {
                      ...formState.training.evangelism,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.evangelism.total}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ደቀመዝሙር ከማፍራት እኳያ የሰለጠኑ ሰዎች ብዛት</TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.choir.male}
                  onValueChange={values => {
                    handleChange("training", "choir", {
                      ...formState.training.choir,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.choir.female}
                  onValueChange={values => {
                    handleChange("training", "choir", {
                      ...formState.training.choir,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.choir.total}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ለቁልፍ መምህራን ሥልጠና የሰለጠኑ</TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.key_teachers.male}
                  onValueChange={values => {
                    handleChange("training", "key_teachers", {
                      ...formState.training.key_teachers,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.key_teachers.female}
                  onValueChange={values => {
                    handleChange("training", "key_teachers", {
                      ...formState.training.key_teachers,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.key_teachers.total}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>በትንንሽ ቡድን መሪዎችና አስጠኚዎች የተስጡ ሥልጠናዎችን የሰለጠኑ</TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.small_group_leaders.male}
                  onValueChange={values => {
                    handleChange("training", "small_group_leaders", {
                      ...formState.training.small_group_leaders,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.small_group_leaders.female}
                  onValueChange={values => {
                    handleChange("training", "small_group_leaders", {
                      ...formState.training.small_group_leaders,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.small_group_leaders.total}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>በእረኝነት ለሚያገለግሉ የተሰጡ ሥልጠናዎችን የሰለጠኑ</TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.shepherding.male}
                  onValueChange={values => {
                    handleChange("training", "shepherding", {
                      ...formState.training.shepherding,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.shepherding.female}
                  onValueChange={values => {
                    handleChange("training", "shepherding", {
                      ...formState.training.shepherding,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.shepherding.total}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ለልጆች የሰንበት ትምህርት አስተማሪዎች የተሰጡ ስልጠናዎችን የሰለጠኑ</TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.sunday_school_teachers.male}
                  onValueChange={values => {
                    handleChange("training", "sunday_school_teachers", {
                      ...formState.training.sunday_school_teachers,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.sunday_school_teachers.female}
                  onValueChange={values => {
                    handleChange("training", "sunday_school_teachers", {
                      ...formState.training.sunday_school_teachers,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.sunday_school_teachers.total}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ለባለትዳሮች የተሰጡ ሥልጠናዎችን ትምህርቶችን የሰለጠኑ</TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.married_couples.male}
                  onValueChange={values => {
                    handleChange("training", "married_couples", {
                      ...formState.training.married_couples,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.married_couples.female}
                  onValueChange={values => {
                    handleChange("training", "married_couples", {
                      ...formState.training.married_couples,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.married_couples.total}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ላላገቡ ወጣቶች የተሰጡ ሥልጠናዎች ትምህርቶችን የሰለጠኑ</TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.unmarried_youth.male}
                  onValueChange={values => {
                    handleChange("training", "unmarried_youth", {
                      ...formState.training.unmarried_youth,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.unmarried_youth.female}
                  onValueChange={values => {
                    handleChange("training", "unmarried_youth", {
                      ...formState.training.unmarried_youth,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.unmarried_youth.total}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ለወጣቶች የተሰጡ ሥልጠናዎችን የሰለጠኑ</TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.youth.male}
                  onValueChange={values => {
                    handleChange("training", "youth", {
                      ...formState.training.youth,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.youth.female}
                  onValueChange={values => {
                    handleChange("training", "youth", {
                      ...formState.training.youth,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.youth.total}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ለእህቶች የተሰጡ ሥልጠናዎችን የሰለጠኑ</TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.sisters.male}
                  onValueChange={values => {
                    handleChange("training", "sisters", {
                      ...formState.training.sisters,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.sisters.female}
                  onValueChange={values => {
                    handleChange("training", "sisters", {
                      ...formState.training.sisters,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.sisters.total}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ለአጠቃላይ አገልጋዮች የተሰጡ ሥልጠናዎችን የሰለጠኑ</TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.general_servants.male}
                  onValueChange={values => {
                    handleChange("training", "general_servants", {
                      ...formState.training.general_servants,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.general_servants.female}
                  onValueChange={values => {
                    handleChange("training", "general_servants", {
                      ...formState.training.general_servants,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.general_servants.total}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ለታዳጊ ወጣቶች የተሰጡ ሥልጠናዎችን የሰለጠኑ</TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.growing_youth.male}
                  onValueChange={values => {
                    handleChange("training", "growing_youth", {
                      ...formState.training.growing_youth,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.growing_youth.female}
                  onValueChange={values => {
                    handleChange("training", "growing_youth", {
                      ...formState.training.growing_youth,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.growing_youth.total}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ነባር መሪዎችን ከማብቃት አኳያ</TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.former_leaders.male}
                  onValueChange={values => {
                    handleChange("training", "former_leaders", {
                      ...formState.training.former_leaders,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.former_leaders.female}
                  onValueChange={values => {
                    handleChange("training", "former_leaders", {
                      ...formState.training.former_leaders,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.former_leaders.total}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>የዘርፍና የንዑስ ዘርፎችን መሪዎች ለማብቃት የተሰጡ ሥልጠና</TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.department_leaders.male}
                  onValueChange={values => {
                    handleChange("training", "department_leaders", {
                      ...formState.training.department_leaders,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.department_leaders.female}
                  onValueChange={values => {
                    handleChange("training", "department_leaders", {
                      ...formState.training.department_leaders,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.department_leaders.total}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>አዳዲስ ተተኪ መሪዎችን ከማፍራት አኳያ የተሰጡ ሥልጠናዎች</TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.new_leaders.male}
                  onValueChange={values => {
                    handleChange("training", "new_leaders", {
                      ...formState.training.new_leaders,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.new_leaders.female}
                  onValueChange={values => {
                    handleChange("training", "new_leaders", {
                      ...formState.training.new_leaders,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.new_leaders.total}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ከሠላም ግንባታ አኳያ የተሰጡ ሥልጠናዎች</TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.peace_building.male}
                  onValueChange={values => {
                    handleChange("training", "peace_building", {
                      ...formState.training.peace_building,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.peace_building.female}
                  onValueChange={values => {
                    handleChange("training", "peace_building", {
                      ...formState.training.peace_building,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.peace_building.total}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ከሁለንተናዊ አገልግሎተ አኳያ የተሰጡ ሥልጠናዎች</TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.dual_ministry.male}
                  onValueChange={values => {
                    handleChange("training", "dual_ministry", {
                      ...formState.training.dual_ministry,
                      male: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.dual_ministry.female}
                  onValueChange={values => {
                    handleChange("training", "dual_ministry", {
                      ...formState.training.dual_ministry,
                      female: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.training.dual_ministry.total}
                  inputProps={{ readOnly: true }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={4}>
                <Stack spacing={1}>
                  <Typography>ሌሎች የሥልጠና ርዕሶችና ሰልጣኞች ካሉ ይጠቀሱ</Typography>
                  <StyledTextField
                    fullWidth
                    defaultValue={formState.training.others}
                    onBlur={e =>
                      handleChange("training", {
                        others: e.target.value
                      })
                    }
                    multiline
                    minRows={3}
                    key={formState.training.others}
                    disabled={!isEditingEnabled}
                  />
                </Stack>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      {!reportId && (
        <Stack alignItems="flex-start">
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSectionComplete(8)}
          >
            ቀጥል
          </Button>
        </Stack>
      )}
    </Stack>
  );
};
